import { Skeleton } from "@tql/ui-components-react/tql/indicators";

import { useBroker } from "~/features/ftl/ftl-header/hooks/use-broker.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

import styles from "./shipment-tendered-rep-modal.module.css";

type ShipmentTenderedRepModalProps = {
	readonly onClose: () => void;
};

/**
 * Shown to vendors after they tender from /ltl-shipment when the response does
 * not include a booked carrier (selectedCarrierPriceId) and PO number. The
 * shipment is instead handed off to the customer's LTL Account Representative,
 * whose contact details are pulled from the broker assigned to the active
 * customer (mirrors the "Need Assistance?" logic in TraxPageHeader).
 */
export const ShipmentTenderedRepModal = ({
	onClose,
}: ShipmentTenderedRepModalProps) => {
	const { broker, isLoading } = useBroker("LTL");
	const name = broker?.name?.trim();
	const extension = broker?.extension?.trim();
	const email = broker?.email?.trim();

	return (
		<TraxModal onClose={onClose} title={"Shipment Tendered"} width={"25%"}>
			<div
				className={styles.repModal}
				data-testid={"shipment-tendered-rep-modal"}
			>
				<div className={styles.message}>
					The shipment has been sent to your LTL Account Representative. You
					will be notified and provided paperwork once ready.
				</div>
				<div className={styles.repDetails}>
					<span>LTL Account Representative:</span>
					{isLoading ? (
						<span
							className={styles.repSkeleton}
							data-testid={"rep-contact-skeleton"}
						>
							<Skeleton animation={{ type: "wave" }} shape={"text"} />
						</span>
					) : (
						<>
							{name ? <span className={styles.repName}>{name}</span> : null}{" "}
							{email ? (
								<a className={"tql-link"} href={`mailto:${email}`}>
									{email}
								</a>
							) : null}{" "}
							{extension ? (
								<a className={"tql-link"} href={`tel:8005803101,${extension}`}>
									{`(800) 580-3101 ext. ${extension}`}
								</a>
							) : null}
						</>
					)}
				</div>
				<div className={styles.thanks}>Thank you for your business!</div>
			</div>
		</TraxModal>
	);
};
